import { render, staticRenderFns } from "./CrossCircleSvg.vue?vue&type=template&id=42271507"
import script from "./CrossCircleSvg.vue?vue&type=script&lang=js"
export * from "./CrossCircleSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports